import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-berry-darker px-4 py-2 text-center text-[13px] sm:text-sm font-medium leading-snug text-white" data-id="element-18" data-mp="2tgqmyhggroie">
      Dit is een digitaal product. Je ontvangt geen fysieke materialen.
    </div>;
}